
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import ScrollToTop from './components/layout/ScrollToTop';
import BackToTopButton from './components/layout/BackToTopButton';
import RouteSeo from './components/RouteSeo';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <RouteSeo />
      <AppRoutes />
      <BackToTopButton />
    </BrowserRouter>
  );
}

export default App;
